module.exports = {
  resend: require('../../resources/icon-resend.png'),
  info: require('../../resources/icon-info.png'),
  reject: require('../../resources/icon-reject.png'),
  approve: require('../../resources/icon-approve.png'),
  immunizationsChecklist: require('../../resources/icon-immunization-checklist.png'),
  calendar: require('../../resources/nav-icon-calendar.png'),
  mail: require('../../resources/icon-contact-blue.png'),
  message: require('../../resources/nav-icon-messaging.png'),
  edit: require('../../resources/icon-edit-small.png'),
  pager: require('../../resources/icon-pager-small.png'),
  preview: require('../../resources/icon-eye.png'),
};
